import React, { Component } from 'react';
import FriendlyDate from '../../../../../../shared/FriendlyDate';
import { TimeZoneNote } from '../../../../../../shared/time-zone-note/TimeZoneNote';
import RiskLevel from '../../../../risk-assessment/risk-level/RiskLevel';
import { Pager } from '../../../../../../shared/pager/Pager';
import { EmptyList } from '../../../../../../shared/empty-list/EmptyList';
import { Sorter } from '../../../../../../shared/table/Sorter';
import * as _ from 'lodash';
import {
    extendWithModalSupport,
    ModalContainer
} from '../../../../../../shared/modal-container/ModalContainer';
import { Filters } from '../../../../../../shared/filters/Filters';
import { EventTypeLabelPipe } from '../../../../../../shared/pipes/EventTypeLabelPipe';
import { FilterBadgeContainer } from '../../../../../../shared/filter-badge-container/FilterBadgeContainer';
import { FilterButton } from '../../../../../../shared/button/filter-button/FilterButton';
import { SpinLoader } from '../../../../../../shared/spin-loader/SpinLoader';
import TransparentButton from '../../../../../../shared/button/transparent-button/TransparentButton';
import { RiskFactorInfoModalContent } from '../../../../risk-assessment/util/RiskFactorInfoModalContent';

export const historyOfEventsTableHeaders = [
    { key: 'EVENT_TIMESTAMP', value: 'Event Timestamp', showArrowSort: true },
    { key: 'EVENT_TYPE', value: 'Event Type', showArrowSort: false },
    { key: 'DESCRIPTION', value: 'Description', showArrowSort: false },
    { key: 'AVERAGE_RISK', value: 'Risk', showArrowSort: true },
    { key: 'ACTIONS', value: null, showArrowSort: false }
];

const ModalMode = Object.freeze({
    FILTERS: 'FILTERS',
    DETAILS: 'DETAILS'
});

class HistoryOfEventsTable extends Component {
    tableStyle = {
        width: '100%',
        marginTop: '16px'
    };

    constructor(props) {
        super(props);
        extendWithModalSupport(this);

        this.state = {
            currentSortingKey: '',
            modalMode: ModalMode.FILTERS,
            selectedEvent: null
        };

        this.handleSort = this.handleSort.bind(this);
    }

    makeFilters = () => {
        const {
            typeConfig,
            severityConfig,
            statusConfig
        } = this.props.filtersConfig;

        return (
            <Filters
                typeConfig={typeConfig}
                severityConfig={severityConfig}
                statusConfig={statusConfig}
                applyFilters={this.handleApplyFilters}
                clearFilters={this.handleClearFilters}
            />
        );
    };

    makeDetailsModalContent = () => (
        <RiskFactorInfoModalContent
            selectedEvent={this.state.selectedEvent}
            closeModal={() => this.modalInstance.closeModal()}
        />
    );

    handleSort = ({ sortingKey, sortDirection }) => {
        this.setState({
            ...this.state,
            currentSortingKey: sortingKey,
            currentDirection: sortDirection
        });
        _.isFunction(this.props.onSortUpdated) &&
            this.props.onSortUpdated({ sortingKey, sortDirection });
    };

    handleApplyFilters = filters => {
        _.isFunction(this.props.applyFilters) &&
            this.props.applyFilters(filters);
        this.modalInstance.closeModal();
    };

    handleClearFilters = filters => {
        _.isFunction(this.props.clearFilters) &&
            this.props.clearFilters(filters);
        this.modalInstance.closeModal();
    };

    handleRemoveFilter = filterValue => {
        const { filters } = this.props;

        const filterType = Object.keys(filters).find(key => {
            return filters[key] === filterValue;
        });

        _.isFunction(this.props.removeFilter) &&
            this.props.removeFilter({ ...filters, [filterType]: null });
    };

    openFiltersModal = () =>
        this.setState(
            {
                ...this.state,
                modalMode: ModalMode.FILTERS,
                selectedEvent: null
            },
            () => this.modalInstance.openModal()
        );

    openDetailsModal = event =>
        this.setState(
            {
                ...this.state,
                modalMode: ModalMode.DETAILS,
                selectedEvent: event
            },
            () => this.modalInstance.openModal()
        );

    getModalContent = () => {
        return this.state.modalMode === ModalMode.DETAILS
            ? this.makeDetailsModalContent()
            : this.makeFilters();
    };

    getModalTitle = () => {
        return this.state.modalMode === ModalMode.DETAILS
            ? 'Details'
            : 'Filters';
    };

    render() {
        const {
            events,
            loading,
            pagination,
            onPaginationUpdated,
            filters
        } = this.props;
        return (
            <div className="event-list table">
                <TimeZoneNote />
                <table style={this.tableStyle}>
                    <tbody>
                        <tr className={'table-options'}>
                            <td
                                colSpan={historyOfEventsTableHeaders.length - 1}
                            >
                                <FilterBadgeContainer
                                    filters={filters}
                                    TypeLabelPipe={EventTypeLabelPipe}
                                    removeFilter={this.handleRemoveFilter}
                                />
                            </td>
                            {/*<td>*/}
                            {/*todo: Commented out until table settings are implemented*/}
                            {/*<FilterButton onClick={() => {}}>*/}
                            {/*    <i className={'material-icons'}>*/}
                            {/*        view_list*/}
                            {/*    </i>*/}
                            {/*    <span>Table Settings</span>*/}
                            {/*</FilterButton>*/}
                            {/*</td>*/}
                            <td>
                                <FilterButton
                                    onClick={() => this.openFiltersModal()}
                                >
                                    <i className={'material-icons'}>
                                        filter_list
                                    </i>
                                    <span>Filter</span>
                                </FilterButton>
                            </td>
                        </tr>
                        <tr className="headers">
                            {historyOfEventsTableHeaders.map(header => (
                                <td key={header.key}>
                                    {header.value}
                                    {header.showArrowSort && (
                                        <Sorter
                                            sortingKey={header.key}
                                            currentSortingKey={
                                                this.state.currentSortingKey
                                            }
                                            onSort={this.handleSort}
                                        />
                                    )}
                                </td>
                            ))}
                        </tr>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={historyOfEventsTableHeaders.length}
                                >
                                    <SpinLoader />
                                </td>
                            </tr>
                        ) : (
                            (events.length &&
                                events.map(event => (
                                    <tr
                                        className="data"
                                        key={event.eventReference}
                                    >
                                        <td>
                                            <FriendlyDate
                                                timestamp={event.eventTimestamp}
                                            />
                                        </td>
                                        <td>{event.friendlyEventType}</td>
                                        <td>{event.description}</td>
                                        <td>
                                            <RiskLevel
                                                riskLevel={
                                                    event.transactionRisk
                                                        .averageRisk
                                                }
                                            />
                                        </td>
                                        <td>
                                            <TransparentButton
                                                onClick={() =>
                                                    this.openDetailsModal(event)
                                                }
                                            >
                                                Details
                                            </TransparentButton>
                                        </td>
                                    </tr>
                                ))) || (
                                <tr
                                    className="data"
                                    style={{ textAlign: 'center' }}
                                >
                                    <td
                                        colSpan={
                                            historyOfEventsTableHeaders.length
                                        }
                                    >
                                        <EmptyList />
                                    </td>
                                </tr>
                            )
                        )}
                        <Pager
                            pagination={pagination}
                            onPaginationChanged={updatedPagination =>
                                onPaginationUpdated &&
                                onPaginationUpdated(updatedPagination)
                            }
                            colspan={historyOfEventsTableHeaders.length}
                        />
                    </tbody>
                </table>
                <ModalContainer
                    title={this.getModalTitle()}
                    content={this.getModalContent()}
                    ref={this.modalRef}
                />
            </div>
        );
    }
}

export default HistoryOfEventsTable;
